import axiosInstance from '@/utils/api.js'

var state = {
  ip_zones: [],
  ip_zones_paged: []
}

var getters = {
  IP_ZONES: (state) => {
    return state.ip_zones
  },
  IP_ZONES_PAGED: (state) => {
    return state.ip_zones_paged
  }
}

var mutations = {
  SET_IP_ZONES: (state, payload) => {
    state.ip_zones = payload
  },
  SET_IP_ZONES_PAGED: (state, payload) => {
    state.ip_zones_paged = payload
  }

}

var actions = {
  GET_IP_ZONES: async (context, payload) => {
    let result = await axiosInstance.get('/referencebooks/ip_zones')
    if (result.status === 200) {
      context.commit('SET_IP_ZONES', result.data)
    }
  },
  GET_IP_ZONES_PAGED: async (context, payload) => {
    let result = await axiosInstance.get('/referencebooks/ip_zones_paged?page=' + payload.page + '&per_page=' + payload.perPage + '&filter=' + payload.filter)
    if (result.status === 200) {
      context.commit('SET_IP_ZONES_PAGED', result.data)
    }
  },
  CREATE_IP_ZONES: (context, payload) => {
    return axiosInstance.post('/referencebooks/ip_zones', payload)
  },
  UPDATE_IP_ZONES: (context, payload) => {
    return axiosInstance.put('/referencebooks/ip_zones', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/referencebooks/IPzones.js